import ThermalPrinterBase from "./ThermalPrinterBase";
import dayjs from "dayjs";
import PrintJobNiceloopV1Builder from "~/class/printer/PrintJobNiceloopV1Builder";
import { JobAction } from "~/interface/Job";


interface Options {
    storeId?: string;
    guests?: number;
    billing?: any;
}
export default class ThermalPrinterJob extends ThermalPrinterBase {  
    printToKitchen(job : any, options: Options){  
          const printJobBuilder =  new PrintJobNiceloopV1Builder(options?.productsStore)

          const serviceValue = printJobBuilder.getBillArrValue(options?.billing?.serviceCharge, 2) || 0
          const vatValue = printJobBuilder.getBillArrValue(options?.billing?.vat, 1) || 0
          const vatMode = printJobBuilder.getBillArrValue(options?.billing?.vat, 0) || 0

          const payload = {
            ...job,
            ...options,
            serviceValue,
            vatValue,
            vatMode,
            
          }
 
          const jobKitchen = printJobBuilder.makePrintJobKitchen(payload).build();
        console.log("jobKitchen=>", jobKitchen)
        this.print_data = jobKitchen
        return this
    }

    printVoidItems(job : any){
      let alias = job ?. table
      if (job ?. channel == "table") {
          alias = `Table ${
              job ?. table
          }`
      }

      const payload = {...job, alias}
      const printJobBuilder =  new PrintJobNiceloopV1Builder()
      const jobVoid =  printJobBuilder.makePrintJobVoid(payload).build();

      console.log("jobVoid=>", jobVoid)
      this.print_data = jobVoid
      return this       
          
    }

    printMoveItems(job : any){
      const payload = {...job, tableOrigin:job.table, tableDestination:job.newTable}
      const printJobBuilder =  new PrintJobNiceloopV1Builder()
      const jobMove =  printJobBuilder.makePrintJobMove(payload).build();

      console.log("jobMove=>", jobMove)
      this.print_data = jobMove
      return this       
          
    }

    printShift(payload:any){
        const shiftWorkJob = [
            {
               "name":"LineFeed",
               "value":true
            },
            {
               "name":"PrintTitle",
               "value":payload.storeInfo?.name || ""
            },
            {
               "name":"LineFeed",
               "value":true
            },
            {
               "name":"PrintTitle",
               "value": payload.table || ""
            },
            {
               "name":"LineFeed",
               "value":true
            },
            {
               "name":"LineFeed",
               "value":true
            },
            {
               "name":"PrintTextLine",
               "value":`วันที่             :   ${dayjs(payload.startTime).format('DD-MM-YYYY')}`
            },
            {
               "name":"PrintTextLine",
               "value":`เริ่ม              :   ${dayjs(payload.startTime).format('HH:mm')}`
            },
            {
               "name":"PrintTextLine",
               "value":`ระยะเวลา      :   ${payload.timeLength} นาที`
            },
            {
               "name":"PrintTextLine",
               "value":`สิ้นสุดเวลา     :   ${dayjs(payload.startTime).add(payload.timeLength, 'minute').format('HH:mm')}`
            },
            {
               "name":"LineFeed",
               "value":true
            },
            {
               "name":"PrintComment",
               "value": payload.note || ""
            },
            {
               "name":"LineFeed",
               "value":true
            },
            {
               "name":"PrintLine",
               "value":true
            },
            {
               "name":"LineFeed",
               "value":true
            }
        ]
        this.print_data = shiftWorkJob
        return this       
    }

    rePrintJob(payload:any){ 
      const reprintJob =  new PrintJobNiceloopV1Builder().makeReprintJobToKitchen(payload).build();
      console.log("reprint job to kitchen=>", reprintJob)
      this.print_data = reprintJob
      return this       
    }    
}
